export default function PHP_printf() {
  return (
    <div>
      <h1>PHP_printf</h1>
    </div>
  );
}
